import PageTitle from "@/components/PageTitle";
import SideBarWrapper from "@/components/SideBarWrapper";
import { User, UsersIcon } from "lucide-react";
import { Listing } from "./Listing";

const Users = () => {
  return (
    <SideBarWrapper>
      <div className="LookUpTabs">
        <div className="content-lookups xl:p-5 p-3">
          <>
            <div>
              <div className="card mb-5 p-3">
                <PageTitle icon={User} pageTitle="Users" />
              </div>
              <Listing />
            </div>
          </>
        </div>
      </div>
    </SideBarWrapper>
  );
};

export default Users;
